/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Business } from '../../models/business';
import { UpdateBusinessRequest } from '../../models/update-business-request';

export interface UpdateBusiness$Params {
      body: UpdateBusinessRequest
}

export function updateBusiness(http: HttpClient, rootUrl: string, params: UpdateBusiness$Params, context?: HttpContext): Observable<StrictHttpResponse<Business>> {
  const rb = new RequestBuilder(rootUrl, updateBusiness.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Business>;
    })
  );
}

updateBusiness.PATH = '/business';
